/** Exact aliases only: mixed breeds and distinct breeds remain separate. */
export function breedNameKey(name: string): string {
  return name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[’]/g, "'").replace(/[.()]/g, '')
    .replace(/\s*([-\/])\s*/g, '$1').replace(/\s+/g, ' ').trim();
}

const aliases = new Map<string, string>();
function addBreed(name: string, variants: string[] = []): void {
  for (const variant of [name, ...variants]) aliases.set(breedNameKey(variant), name);
}

addBreed('European sled dog (ESD)', ['ESD', 'E.S.D', 'E S D', 'European Sled Dog', 'European Sled Dog ESD']);
addBreed('Husky sibérien', ['Husky', 'Husky de Sibérie', 'Siberian Husky']);
addBreed('Berger belge malinois', ['Malinois', 'Chien de berger belge (malinois)', 'Belgian malinois']);
addBreed('Alaskan husky', ['Alaskan']);
addBreed('Staffordshire bull terrier', ['Staffie', 'Staffy']);
addBreed('American staffordshire terrier', ['Amstaff', 'Staffordshire terrier américain', 'American staffordshire']);
addBreed('Berger australien', ['Australian shepherd']);
addBreed('Border collie', ['Border colie', 'Bordercollie']);
addBreed('Berger allemand', ['German shepherd']);
addBreed('Berger blanc suisse', ['White swiss shepherd']);
addBreed('Labrador retriever', ['Labrador']);
addBreed('Golden retriever', ['Golden']);
addBreed('Braque de Weimar', ['Braque de weimar', 'Weimaraner']);
addBreed('Épagneul breton', ['Epagneul breton', 'Brittany spaniel']);
addBreed('Greyster');
addBreed('Eurohound');
addBreed('Jack russell terrier', ['Jack russell']);
addBreed('Berger belge tervueren', ['Tervueren']);
addBreed('Berger belge groenendael', ['Groenendael']);

/** Sentence case for every label, with sporting abbreviations kept readable. */
function formatBreedName(name: string): string {
  const lower = name.toLocaleLowerCase('fr');
  return (lower.charAt(0).toLocaleUpperCase('fr') + lower.slice(1))
    .replace(/\besd\b/g, 'ESD').replace(/\blof\b/g, 'LOF');
}

export function normalizeBreedName(breed?: string): string {
  const name = breed?.trim().replace(/\s+/g, ' ');
  return name ? aliases.get(breedNameKey(name)) || formatBreedName(name) : 'Unknown Breed';
}
